/**
 * Complimentary gift — PDP picker + cart qty/remove linking (VG-live parity, cleaned up)
 * Data: collection metafields custom.free_gifts / custom.free_gift_title
 *
 * Cart rules (same intent as VG-live):
 * - Parent line stores properties[_free_gift_id] = gift variant id
 * - Gift line stores properties[_free_product] = true
 * - Parent qty change → gift qty matches
 * - Parent remove → gift qty decreases by removed parent qty (to 0 when fully removed)
 */
(function () {
  'use strict';

  var INPUT_NAME = 'properties[_free_gift_id]';
  var pendingGiftSync = null;
  var syncingGift = false;

  function cartAddUrl() {
    return (
      (window.theme && theme.routes && theme.routes.cartAdd) ||
      (window.routes && window.routes.cart_add_url) ||
      '/cart/add.js'
    );
  }

  function cartChangeUrl() {
    return (
      (window.theme && theme.routes && theme.routes.cartChange) ||
      '/cart/change.js'
    );
  }

  function getRoot(scope) {
    if (scope && scope.querySelector) {
      return (
        scope.querySelector('[data-vg-gift]') ||
        (scope.matches && scope.matches('[data-vg-gift]') ? scope : null)
      );
    }
    return document.querySelector('[data-vg-gift]');
  }

  function getSelectedId(root) {
    if (!root) return '';
    var selected = root.querySelector('[data-vg-gift-item].is-selected');
    if (selected) return String(selected.getAttribute('data-gift-id') || '');
    var input = root.querySelector('[data-vg-gift-input]');
    return input ? String(input.value || '') : '';
  }

  function setSelected(root, item) {
    if (!root || !item) return;
    root.querySelectorAll('[data-vg-gift-item]').forEach(function (el) {
      var on = el === item;
      el.classList.toggle('is-selected', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var id = item.getAttribute('data-gift-id') || '';
    var input = root.querySelector('[data-vg-gift-input]');
    if (input) input.value = id;
    syncFormInputs();
  }

  function syncFormInputs() {
    var root = getRoot(document);
    if (!root) return;
    var id = getSelectedId(root);
    document.querySelectorAll('[data-ph-buy-form]').forEach(function (form) {
      var field = form.querySelector('[name="' + INPUT_NAME + '"]');
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = INPUT_NAME;
        field.setAttribute('data-vg-gift-form-input', '');
        form.appendChild(field);
      }
      field.value = id;
    });
  }

  function updateNavState(root) {
    if (!root) return;
    var track = root.querySelector('[data-vg-gift-track]');
    var prev = root.querySelector('[data-vg-gift-prev]');
    var next = root.querySelector('[data-vg-gift-next]');
    if (!track || !prev || !next) return;
    var scrollable = track.scrollWidth > track.clientWidth + 2;
    prev.hidden = !scrollable;
    next.hidden = !scrollable;
    if (!scrollable) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max;
  }

  function bindPicker(root) {
    if (!root || root.dataset.vgGiftBound) return;
    root.dataset.vgGiftBound = '1';

    root.querySelectorAll('[data-vg-gift-item]').forEach(function (item) {
      item.addEventListener('click', function () {
        setSelected(root, item);
      });
    });

    var track = root.querySelector('[data-vg-gift-track]');
    var prev = root.querySelector('[data-vg-gift-prev]');
    var next = root.querySelector('[data-vg-gift-next]');

    if (track && prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -track.clientWidth * 0.75, behavior: 'smooth' });
      });
    }
    if (track && next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth * 0.75, behavior: 'smooth' });
      });
    }
    if (track) {
      track.addEventListener(
        'scroll',
        function () {
          updateNavState(root);
        },
        { passive: true }
      );
      updateNavState(root);
      window.addEventListener(
        'resize',
        function () {
          updateNavState(root);
        },
        { passive: true }
      );
    }

    syncFormInputs();
  }

  function addSelectedGift(form) {
    var root = getRoot(document);
    var giftId = getSelectedId(root);
    if (!giftId) return Promise.resolve(null);

    var qtyInput = form && form.querySelector('[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!qty || qty < 1) qty = 1;

    var body = new URLSearchParams();
    body.set('id', giftId);
    body.set('quantity', String(qty));
    body.set('properties[_free_product]', 'true');

    return fetch(cartAddUrl(), {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
    }).then(function (r) {
      return r.json();
    });
  }

  function changeLineQty(idOrKey, qty) {
    if (idOrKey == null || idOrKey === '' || (typeof idOrKey === 'number' && isNaN(idOrKey))) {
      return Promise.reject(new Error('no valid id or line parameter'));
    }

    return fetch(cartChangeUrl() + '?t=' + Date.now(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: idOrKey,
        quantity: qty,
      }),
    }).then(function (r) {
      return r.json();
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function findFreeGiftLine(cart, giftVariantId) {
    var items = (cart && cart.items) || [];
    var match = null;
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (String(item.variant_id) !== String(giftVariantId)) continue;
      var props = item.properties || {};
      if (props._free_product === true || props._free_product === 'true') {
        return item;
      }
      if (!match) match = item;
    }
    return match;
  }

  function setGiftQtyByVariant(giftVariantId, qty) {
    return fetchCart().then(function (cart) {
      var giftLine = findFreeGiftLine(cart, giftVariantId);
      if (!giftLine || !giftLine.key) {
        return null;
      }
      return changeLineQty(giftLine.key, qty);
    });
  }

  function rebuildCart() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function readGiftId(el) {
    if (!el) return '';
    return (
      el.getAttribute('data-free-gift-id') ||
      el.getAttribute('data-free_gift_id') ||
      ''
    );
  }

  /* Parent qty changed via theme QtySelector → sync gift (live parity) */
  function onCartQuantity(evt) {
    if (syncingGift) return;
    var key = evt.detail && evt.detail[0];
    var qty = evt.detail && evt.detail[1];
    var wrapper = evt.detail && evt.detail[2];
    if (!wrapper || qty == null || qty === '') return;

    var giftId = readGiftId(wrapper);
    if (!giftId || giftId === '0') return;

    qty = parseInt(qty, 10);
    if (isNaN(qty)) return;

    /*
      Impulse CartForm skips qty 0 (`if (!key || !qty) return`), so cart:updated
      never runs and the gift would be stranded. Live updates both lines directly.
      Use the gift line item key (not bare variant id) — required when the line
      has properties like _free_product.
    */
    if (qty <= 0) {
      if (!key) return;
      syncingGift = true;
      setGiftQtyByVariant(giftId, 0)
        .then(function () {
          return changeLineQty(key, 0);
        })
        .then(function () {
          syncingGift = false;
          if (document.body.classList.contains('template-cart')) {
            window.location.reload();
            return;
          }
          rebuildCart();
        })
        .catch(function () {
          syncingGift = false;
          rebuildCart();
        });
      return;
    }

    pendingGiftSync = { giftId: String(giftId), qty: qty };
  }

  function onCartUpdated() {
    if (!pendingGiftSync || syncingGift) return;
    var sync = pendingGiftSync;
    pendingGiftSync = null;
    syncingGift = true;

    setGiftQtyByVariant(sync.giftId, sync.qty)
      .then(function () {
        syncingGift = false;
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function () {
        syncingGift = false;
      });
  }

  function onCartRemoveClick(evt) {
    var remove =
      evt.target && evt.target.closest
        ? evt.target.closest('.cart__remove')
        : null;
    if (!remove || remove.classList.contains('wi_bundle-cart-remove')) return;

    var giftId = readGiftId(remove);
    if (!giftId || giftId === '0') return;

    var link = remove.querySelector('a[href*="quantity=0"]') || remove.querySelector('a');
    var href = link && link.getAttribute('href');
    var keyMatch = href && href.match(/[?&]id=([^&]+)/);
    var parentKey = keyMatch ? decodeURIComponent(keyMatch[1]) : null;
    if (!parentKey) return;

    evt.preventDefault();
    evt.stopPropagation();
    if (typeof evt.stopImmediatePropagation === 'function') {
      evt.stopImmediatePropagation();
    }

    var cartItem = remove.closest('.cart__item');
    var qtyInput = cartItem && cartItem.querySelector('.js-qty__num');
    var parentQty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!parentQty || parentQty < 1) parentQty = 1;

    syncingGift = true;

    /* Complimentary first, then parent (same order as qty→0) */
    fetchCart()
      .then(function (cart) {
        var giftLine = findFreeGiftLine(cart, giftId);
        var giftPromise = giftLine && giftLine.key
          ? changeLineQty(giftLine.key, Math.max(0, (giftLine.quantity || 0) - parentQty))
          : Promise.resolve(null);
        return giftPromise.then(function () {
          return changeLineQty(parentKey, 0);
        });
      })
      .then(function () {
        syncingGift = false;
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return;
        }
        rebuildCart();
      })
      .catch(function () {
        syncingGift = false;
        rebuildCart();
      });
  }

  function bindCartListeners() {
    if (document.documentElement.dataset.vgGiftCartBound) return;
    document.documentElement.dataset.vgGiftCartBound = '1';

    document.addEventListener('cart:quantity.cart-cart-drawer', onCartQuantity);
    document.addEventListener('cart:quantity.cart-header', onCartQuantity);
    document.addEventListener('cart:quantity.cart-page', onCartQuantity);
    document.addEventListener('cart:quantity.cart-drawer', onCartQuantity);
    document.addEventListener('cart:updated', onCartUpdated);
    document.addEventListener('click', onCartRemoveClick, true);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-vg-gift]').forEach(bindPicker);
    syncFormInputs();
    bindCartListeners();
  }

  window.VGComplimentaryGift = {
    init: initAll,
    syncFormInputs: syncFormInputs,
    getSelectedId: function () {
      return getSelectedId(getRoot(document));
    },
    addSelectedGift: addSelectedGift,
  };

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });
  if (document.readyState !== 'loading') initAll(document);

  document.addEventListener('shopify:section:load', function () {
    initAll(document);
  });
})();
